import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/efs/PageHeader';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <PageHeader title={t('efs.common.errors.not_found_title')} />
      <div className="efs-panel p-6 text-sm text-efs-text-muted">
        <p>{t('efs.common.errors.not_found_body')}</p>
        <Button asChild variant="outline" className="mt-4">
          <Link to="/">{t('efs.common.errors.back_home')}</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
